module.exports = __webpack_public_path__ + "img/8.0eb2768f.png";